
import { Model } from 'backbone';

class BehaviorToolboxPaneModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }
}

export default BehaviorToolboxPaneModel;
